module.exports = __webpack_public_path__ + "files/2ec2f6a0814d9f16c48315994d949c32.png";